import { render, staticRenderFns } from "./deposite-chart.vue?vue&type=template&id=1ede1b80"
import script from "./deposite-chart.vue?vue&type=script&lang=js"
export * from "./deposite-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports